import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import {savaScore} from "@/servers/storeManageApi";
import './index.scss'
import {Button, Modal, Input, message, Collapse, Tooltip} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../../../servers/menuAPI";
import store from "../../../../../../redux";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../../../redux/common/action";
import {selectPicDetail} from "../../../../../../servers/menu";
import {gotonext} from "../../../../../../utils";
const { confirm } = Modal;
const { Panel } = Collapse;

@CBaseComponent
class System extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    // this.onBlur = this.onBlur.bind(this)
   this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
    this.createMarkup = this.createMarkup.bind(this)
    this.computedData = this.computedData.bind(this)
    this.modalCancel = this.modalCancel.bind(this)
  }


  state = {
    data: [],
    addressInfo: null,
    tips:'',
    searchData: {
      value: '',//搜索框筛选
      placeholder: '请输入评分'
    },
    isModalVisible:false
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  onSubmit(data){
    let showalert = false
    const that = this
    this.state.data.forEach(item=>{
      if (Number(item.scoremax)!==0 && item.score === '') {
        showalert = true
      }
    })
    gotonext()
    if (showalert) {
      confirm({
        title: '提示',
        content: '存在未打分项,确认下一步？',
        onOk() {
          that.props.history.push({
            pathname: '/informationDeclaration/standardManage/goods/goodsselectScore',
          });
        }
      });
    } else{
      this.props.history.push({
        pathname: '/informationDeclaration/standardManage/goods/goodsselectScore',
      });
    }
  }

  onSelect(){
    const params = {
      annual:getStorage('year'),
      indid:'1.1.3',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      res.records.forEach(item=>{
        item.pff = ''
      })
            this.setState({
        data:res.records,
        tips: res.extra?res.extra:''
      },()=>{
        const element = document.getElementById('top');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
        }
      })
    })
  }

   computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  onBlur(e,annexdefids,scoremax){
    if (e.target.value !== '' && e.target.value !== null) {
      if (Number(e.target.value)>Number(scoremax)){
        message.error('输入的分值不能大于最大值');
        return false
      }
      if (e.target.value != 0) {
        if (!(/(^[1-9]\d*$)/.test(e.target.value))) {
          message.error('输入的分值应为正整数');
          return false;
        }
      }
      e.persist()
      const params = [{
        score: e.target.value,
        id:annexdefids
      }]
      console.log(params);
      savaScore(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('打分成功');
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        const type = res.records[0].filename.split('.')[res.records[0].filename.split('.').length - 1]
        clearTimeout(timer)
        window.open(res.records[0].filepreviewurl, '_blank')
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          {this.state.tips.scoretips?
              <div className="import">
                <Collapse accordion>
                  <Panel header="考察要点" key="1">
                    <div style={{fontWeight:'bold',color:'red',fontSize:'18px'}}>
                      {this.state.tips!==''?this.computedData(decodeURIComponent(this.state.tips.scoretips)):''}
                    </div>
                  </Panel>
                </Collapse>
              </div>:''
          }
          {this.state.data.map((item,index)=>{
            return (
                <div className="detail-item">
                  <div className='detail-title'>
                     <span style={{display:"flex",alignItems:'center'}}>
                      <div style={{width:'90%'}}>{item.name}</div>
                      {item.formtips?
<Tooltip placement="left" title={this.computedData(decodeURIComponent(item.formtips))}>                            <span style={{color:'orange',marginLeft:'10px',cursor:'pointer',width:'85px',display:'block'}}>评分要点</span>
                          </Tooltip>:''
                      }
                    </span>
                    <div className='detail-score'>
                      <div className='scoreintro' style={{color:'red'}}>{item.scorelabel}</div>
                      {Number(item.scoremax)!==0?
                          <Input value={item.score}  maxLength={20} style={{width:'100px'}}
                                 onBlur={event=>this.onBlur(event,item.id,item.scoremax)}
                                 onChange={(e) => this.changeinput(e,index)}
                          />
                          :''
                      }
                    </div>
                  </div>
                  {item.annextypes?
                      <div className='detail-content' style={{margin:'10px 0'}}>
                        <span style={{fontWeight:'bold',marginRight:'15px'}}>附件类别名称:</span>{item.annextypes}
                      </div>:''
                  }
                  <div className='detail-content'>
                     {this.computedData(decodeURIComponent(item.fillin))}
                  </div>
                  <ul className='uploadlistScore'>
                    {
                      item.annexlist.length>0?
                          item.annexlist.map((item1,index1)=>{
                            return <li>
                              <span>{index1+1}.{item1.filename}</span>
                              <div>
                                <span className="textbtn" onClick={()=>{this.downloads(item1)}}>下载</span>
                                <span className="textbtn" onClick={()=>{this.handlePreview(item1)}}>预览</span>
                              </div>
                            </li>
                          }):''
                    }
                  </ul>
                  {/*<div className='detail-info'>*/}
                  {/*  <div className='info-icon'>*/}
                  {/*    <img src={important} alt=""/>*/}
                  {/*  </div>*/}
                  {/*  <div>*/}
                  {/*    {item.tips}*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
            )
          })}
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
            <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>
          </div>
          <Modal title="附件预览" visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
            <div style={{width:'100%',minHeight:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(System);
